import { Controller } from "@hotwired/stimulus";

export default class TabNavController extends Controller {
  static targets = ["tab"];
  declare readonly hasTabTarget: boolean;
  declare readonly tabTarget: HTMLAnchorElement;
  declare readonly tabTargets: HTMLAnchorElement[];

  toggle(event: Event): void {
    for (const tab of this.tabTargets) {
      if (tab === event.target) {
        tab.setAttribute("aria-current", "page");
      } else if (tab.hasAttribute("aria-current")) {
        tab.removeAttribute("aria-current");
      }
    }
  }
}
